<div class="saved-cart-details-container">
  <div class="row col-12 col-sm-12 manage-user-container saved-cart-container my-account-container">
    <div class="col-3 col-sm-3 left-side my-account-left-nav">
      <app-my-account-left-sidenav [navState]="'MyOrdersNavNode'"
      [childNavState]="'SavedShoppingCartNavNode'"></app-my-account-left-sidenav>
    </div>

    @if ( savedCartDetails$|async; as savedCartDetails) {
      <div class="myAccountMyProfile col-12 col-sm-12 col-md-12 col-lg-9 right-side my-account-right-nav"
        >
        <h1 class="manageUserTopHeader m-0">{{'common.text_account_savedCart_title_details'|cxTranslate}}
        </h1>
        <div class="well well-tertiary well-lg saved-cart-detail-block">
          <div class="row">
            <div class="col-xs-12 col-sm-12 col-no-padding saved-cart-top-block">
              <div class="row">
                <div class="col-xs-12 col-sm-12 col-md-12 col-lg-4 item-wrapper">
                  <div class="item-group ed-name-wpr d-flex">
                    <span
                    class="item-label">{{'common.basket_save_cart_name'|cxTranslate}}:&nbsp;</span>
                    <span class="item-value ed-cart-name d-flex">
                      @if (!showNameText) {
                        <span
                        class="name-text">{{$any(savedCartDetails)?.savedCartData?.name}}</span>
                      }
                      @if (showNameText) {
                        <input
                          (blur)="saveName($any(savedCartDetails)?.savedCartData?.code, $any(savedCartDetails)?.savedCartData?.description)"
                          id="editsaveCartName" [(ngModel)]="name" name="Name"
                          class="form-control save-name-desc" type="text" data-val="test2"
                          value="test2" maxlength="25" autocomplete="off">
                      }
                      <button (click)="editName($any(savedCartDetails)?.savedCartData?.name)"
                        class="btn saved-cart-edit-icon d-flex" type="button" data-field="name"><img
                      src="/icons/pencil-fill.svg" alt="Edit name"></button>
                    </span>
                  </div>
                  @if (!name && showNameText) {
                    <p class="chk-error hidden cart-name-error">
                    {{'common.please_enter_the_cart_name'|cxTranslate}}</p>
                  }
                </div>
                <div class="col-xs-12 col-sm-12 col-md-12 col-lg-3 item-wrapper">
                  <div class="item-group">
                    <span class="item-label">{{'common.saved_cart_id_text'|cxTranslate}}:&nbsp;</span>
                    <span class="item-value"
                    id="savedCartCode">{{$any(savedCartDetails)?.savedCartData?.code}}</span>
                  </div>
                </div>
                <div class="col-xs-12 col-sm-12 col-md-12 col-lg-2 item-wrapper">
                  <div class="item-group">
                    <span
                    class="item-label">{{'common.text_account_savedCart_position'|cxTranslate}}:&nbsp;</span>
                    <span
                    class="item-value">{{$any(savedCartDetails)?.savedCartData?.entries.length}}</span>
                  </div>
                </div>
                <div class="col-xs-12 col-sm-12 col-md-12 col-lg-3 item-wrapper">
                  <div class="item-group">
                    <span
                    class="item-label">{{'common.text_account_savedCart_dateSaved'|cxTranslate}}:&nbsp;</span>
                    <span class="item-value">
                    {{formatDate($any(savedCartDetails)?.savedCartData?.saveTime,$any(savedCartDetails)?.savedCartData?.dateFormat)}}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 saved-cart-top-description">
              <div class="saved-cart-desc d-flex">
                <span
                class="item-label">{{'common.text_account_savedCart_description'|cxTranslate}}:&nbsp;</span>
                @if (!showDescText) {
                  <div class="desc-text item-label">
                  {{$any(savedCartDetails)?.savedCartData?.description}}</div>
                }
                <span class="item-value" [ngClass]="{'text-area-display':showDescText}">
                  @if (showDescText) {
                    <textarea
                      (blur)="saveDesc($any(savedCartDetails)?.savedCartData?.code, $any(savedCartDetails)?.savedCartData?.name)"
                      id="editSaveCartDescription" [(ngModel)]="description"
                      name="description" class="form-control save-name-desc" data-val="tes2 desc"
                    maxlength="255"></textarea>
                  }
                  <button (click)="editDesc($any(savedCartDetails)?.savedCartData?.description)"
                    class="btn saved-cart-edit-icon d-flex" type="button" data-field="description"><img
                  src="/icons/pencil-fill.svg"></button>
                </span>
              </div>
            </div>
          </div>
        </div>
        <div class="checkout-order-summary saved-cart-order-summary">
          @if ($any(savedCartDetails).savedCartData && $any(savedCartDetails).savedCartData.entries.length>0) {
            <ul class="checkout-order-summary-list"
              >
              <div class="mainEntryGroup">
                @for (item of $any(savedCartDetails).savedCartData.entries; track item) {
                  <li class="checkout-order-summary-list-items saved-cart-details d-flex"
                    >
                    <div class="thumb">
                      <a [routerLink]=" {cxRoute: 'product',params: item?.product} | cxUrl " tabindex="0">
                        <cx-media [container]="item.product?.images?.['PRIMARY'] || item.product?.images">
                        </cx-media>
                      </a>
                    </div>
                    <div class="checkout-EntryNumber" data-entrynum="0">
                    {{item.updatedEntryNumber}}</div>
                    <div class="details">
                      <div class="checkout-Entryitem-block saved-cart-order-summary-block">
                        <div class="row">
                          <div class="col-xs-12 col-sm-12 col-md-12 col-lg-8">
                            <div class="name">
                              <a class="name"
                              [routerLink]="{cxRoute: 'product',params: item?.product} | cxUrl">{{item.product.code}}</a>
                            </div>
                            <div class="">
                            {{item.product.typenumber}}</div>
                            <div class="">
                            {{item.product.description}}</div>
                          </div>
                          <div class="col-xs-12 col-sm-12 col-md-12 col-lg-2 saved-cart-qty">
                            <div class="qty-cart-wpr">
                              <span>{{'common.text_account_order_qty'|cxTranslate}}:&nbsp;</span>
                              <span class="saved-cart-qty-label"> {{item?.quantity}}</span>
                            </div>
                          </div>
                          <div class="col-xs-12 col-sm-12 col-md-12 col-lg-2 saved-cart-remove text-center"
                            data-entrynumber="0">
                            <button class="btn js-remove-save-cart-row saveCart-remove"
                              (click)="removeEntry($any(savedCartDetails)?.savedCartData?.code, item.entryNumber)">
                              <img src="/images/close.svg" alt="Remove Entry">
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </li>
                }
              </div>
            </ul>
          }
        </div>
        <div class="accountActions-bottom saved-cart-actions-block">
          <div class="row">
            <div class="col-xs-12 col-sm-6 col-md-6 d-none d-sm-none d-md-none d-lg-block">
              <a (click)="back()" class="back-to-savedcart-link">
              {{'common.text_account_savedCart_backToSavedCarts'|cxTranslate}}</a>
            </div>
            <div class="col-xs-12 col-sm-6 col-md-6">
              <div class="row">
                <div class="col-xs-12 col-sm-12 col-md-12 pull-right">
                  <button (click)="restore()" id="restoreButton"
                    class="btn btn-primary btn-block grey-btn restore-button">
                    {{'common.text_account_savedCart_restore'|cxTranslate}}<img
                    class="down-arrow hover-img" src="/icons/link-grey.svg">
                  </button>
                </div>
              </div>
            </div>
            <div class="col-xs-12 col-sm-12 savedCart-backLink d-block d-sm-block d-md-block d-lg-none">
              <a (click)="back()" class="back-to-savedcart-link">
              {{'common.text_account_savedCart_backToSavedCarts'|cxTranslate}}</a>
            </div>
          </div>
        </div>
      </div>
    }
  </div>
</div>